import { render, staticRenderFns } from "./value.vue?vue&type=template&id=ba36a166&lang=pug"
import script from "./value.vue?vue&type=script&setup=true&lang=ts"
export * from "./value.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports